import React, { useState } from "react";
import styled from "styled-components";
import ReactYouTube from "react-youtube";
import { useTranslation } from "react-i18next";

//
import PlayIcon from "../../../components/play-icon/PlayIcon";
import Modal from "../../../components/modal/Modal";
import BGIMG from "../../../assets/images/about-clinic-vd-bg.jpg";

export default function AboutClinicVd() {
  const { t } = useTranslation();
  const [isHidden, setIsHidden] = useState(true);

  const opts = {
    height: "500",
    width: "890",
  };

  function handleChangeIsHidden(v) {
    setIsHidden(v);
  }

  return (
    <StyledAboutClinicVd>
      <div className="container">
        <div className="about-clinic-vd__wrap">
          <PlayIcon
            bg="--light-blue"
            iconBg="--white"
            hover="static"
            onClick={() => handleChangeIsHidden(false)}
          />
          <h1 dangerouslySetInnerHTML={{ __html: t("aboutClinicVdTitle") }} />
        </div>
      </div>
      <Modal isHidden={isHidden} onClose={() => handleChangeIsHidden(true)}>
        <ReactYouTube videoId={isHidden ? "" : "AUd8L94Gv6A"} opts={opts} />
      </Modal>
    </StyledAboutClinicVd>
  );
}

const StyledAboutClinicVd = styled.section`
  padding: 200px 0;
  background-image: url(${BGIMG});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  border: 1px solid var(--border);
  border-right: 0;
  border-left: 0;

  .about-clinic-vd {
    &__wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 32px;

      h1 {
        color: var(--title);
        text-align: center;
        font-size: var(--fs-section-title);
        font-style: normal;
        font-weight: var(--fw-semibold);
        line-height: var(--lh-title);
        max-width: 850px;

        span {
          color: var(--light-blue);
        }
      }
    }
  }
`;
